module.exports = __webpack_public_path__ + "static/img/main_point_img07.ec1c3a31.svg";